// src/components/services/AILegalResearcher/QueryDetails/ExportStatusBadge.jsx
import React from 'react';
import { AlertCircle, Clock } from 'lucide-react';

/**
 * A component that shows the export availability status for a query
 * based on its completion status
 */
const ExportStatusBadge = ({ status }) => {
  if (status === 'Completed') {
    return null; // No badge needed for completed queries
  }
  
  if (status === 'Processing') {
    return (
      <div className="absolute -top-1 -right-1 bg-amber-100 text-amber-800 text-xs px-2 py-1 rounded-full flex items-center shadow-sm border border-amber-200 whitespace-nowrap">
        <Clock className="h-3 w-3 mr-1" />
        <span>Export available when completed</span>
      </div>
    );
  }
  
  // Error or other statuses
  return (
    <div className="absolute -top-1 -right-1 bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full flex items-center shadow-sm border border-red-200 whitespace-nowrap">
      <AlertCircle className="h-3 w-3 mr-1" />
      <span>Export unavailable</span>
    </div>
  );
};

export default ExportStatusBadge;